export default function horizontalScroll(element) {
    const scrollableElement = element;
    let isDown = false;
    let startX;
    let scrollLeft;

    scrollableElement.addEventListener('mousedown', (e) => {
        isDown = true;
        scrollableElement.classList.add('scrolling');
        startX = e.pageX - scrollableElement.offsetLeft;
        // eslint-disable-next-line prefer-destructuring
        scrollLeft = scrollableElement.scrollLeft;
    });

    scrollableElement.addEventListener('mouseleave', () => {
        isDown = false;
        scrollableElement.classList.remove('scrolling');
    });

    scrollableElement.addEventListener('mouseup', () => {
        isDown = false;
        scrollableElement.classList.remove('scrolling');
    });

    scrollableElement.addEventListener('mousemove', (e) => {
        if(!isDown) return;
        e.preventDefault();
        const x = e.pageX - scrollableElement.offsetLeft;
        const walk = (x - startX) * 3;
        scrollableElement.scrollLeft = scrollLeft - walk;
    });

    function scrollTo(toElement) {
        const previousElement = toElement.previousElementSibling || toElement;

        scrollableElement.scrollTo({
            left: previousElement.offsetLeft - 24,
            behavior: 'smooth',
        });
    }

    return {
        element: scrollableElement,
        scrollTo
    };
}
